import BaseModel from '../core/BaseModel'
export default class ProductSerialNumberViewModel extends BaseModel {
    constructor() {
        super({ 
                name: "product_serial_number_view",
                tableName: 'core_product_serial_number'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            serial_number: { 
                name: 'serial_number', 
                type: "String", 
                label: 'Serial number',
                sortable: true,
                headerClass: 'txt-left',
                bodyClass: 'txt-center',
                filter: { type: 'input', match: 'contains'}
            },
            production_status: { 
                name: 'production_status', 
                type: "Selection",
                label: 'Trạng thái sản xuất',
                dataType: 'Label',
                headerClass: 'txt-left',
                bodyClass: 'txt-center',
                options: [{ value: 1, label: 'Đã sản xuất'}, { value: 0, label: 'Chưa sản xuất'}, { value: 2, label: 'Không sản xuất'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                sortable: true
            },
            product_id: {
                refs: ' production_order { manufacturing_date } product { model_code name} ',
                display: false
            }
        },)
    }

}